import {LoginActions, LoginActionTypes} from '@login/ngrx/login.actions';
import {PermissionsModel} from '@shared/models/permission.model';
import {WebOwnProfileModel} from "@services/back-office/model/webOwnProfileModel";

export interface State {
    permissions: PermissionsModel[] | null;
    currentUser: WebOwnProfileModel | null;
}

export const initialState: State = {
    permissions: null,
    currentUser: null,
};

export function reducer(state = initialState, action: LoginActions): State {
    switch (action.type) {
        /** Load User */
        case LoginActionTypes.LoadUser:
            return {
                ...state,
            };

        case LoginActionTypes.LoadUserSuccess:
            return {
                ...state,
                currentUser: action.payload,
            };

        case LoginActionTypes.LoadUserFailure:
            return {
                ...state,
            };

        /** Set User */
        case LoginActionTypes.SetUser:
            return {
                ...state,
                currentUser: action.payload,
            };

        /** Set Permissions */
        case LoginActionTypes.SetPermissions:
            return {
                ...state,
                permissions: action.payload,
            };

        /** Set Initial State */
        case LoginActionTypes.SetInitialState:
            return {...initialState};

        default:
            return state;
    }
}
